module.exports = "https://99designs-start-assets.imgix.net/js/ecedeb1005e1aadd0c27ecc8d840d06b.png";